// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "An Image-quote widget, ideal for integrating quotes and the person into your stories.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Image quote",
  id: "image-quote",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/image-quote/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ImageQuoteConfigTool" */ "app/components/tools/ImageQuoteConfigTool/ImageQuoteConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ImageQuoteConfigTool"]
  })
};

export default CONFIG;
